import { render, staticRenderFns } from "./CatalogTeams.vue?vue&type=template&id=a2b2daae&scoped=true&"
import script from "./CatalogTeams.vue?vue&type=script&lang=js&"
export * from "./CatalogTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b2daae",
  null
  
)

export default component.exports